import BrochureView from "./BrochureView.component";

export default BrochureView;
